import { render, staticRenderFns } from "./CustomRedirectsSection.vue?vue&type=template&id=38e61258&scoped=true"
import script from "./CustomRedirectsSection.vue?vue&type=script&lang=js"
export * from "./CustomRedirectsSection.vue?vue&type=script&lang=js"
import style0 from "./CustomRedirectsSection.vue?vue&type=style&index=0&id=38e61258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e61258",
  null
  
)

export default component.exports